import React from "react";
import "./../../styles/places.css";
import { Container, Row, Col } from "reactstrap";
import tour1 from "./../../assets/images/short-tour2.jpg";
import Newsletter from "../../shared/Newsletter";
import { Helmet } from "react-helmet";

const JaipurTour = () => {
  return (
    <>
      <Helmet>
        <title>Jaipur, Rajasthan - The Rustic Paths</title>

        <meta charset="UTF-8" />

        <meta name="viewport" content="width=device-width, initial-scale=1.0" />

        <meta
          name="description"
          content="Explore the enchanting city of Jaipur in Rajasthan, India with The Rustic Paths. Discover the rich cultural heritage, majestic palaces, and vibrant markets. Plan your trip to Jaipur with our expert private driver services and customizable tour packages."
        />
        <meta
          name="keywords"
          content="Jaipur, Rajasthan, private driver, tour packages, cultural heritage, palaces, markets"
        />
        <meta name="author" content="The Rustic Paths" />
        <meta name="robots" content="index, follow" />
      </Helmet>

      <div className="center-content">
        <h1 className="centered-title text-3xl font-bold mt-6 mb-4">Jaipur</h1>
        <section>
          <Container>
            <Row>
              <Col lg="12">
                <div className="details__container mx-auto">
                  <div className="mb-4 ">
                    <h2
                      className="text-xl font-semibold"
                      style={{ textAlign: "left" }}
                    >
                      Destinations Covered:
                    </h2>
                    <ul className="list-disc pl-4">
                      <li>Amer Fort</li>
                      <li>Hawa Mahal</li>
                      <li>Jantar Mantar</li>
                      <li>City Palace</li>
                      <li>Nahargarh Fort</li>
                    </ul>
                  </div>

                  <h2
                    className="text-xl font-semibold"
                    style={{ textAlign: "left" }}
                  >
                    About Jaipur
                  </h2>
                  <Col lg="6">
                    <div className="wrapingimage">
                      <img src={tour1} alt="" />
                    </div>
                  </Col>
                  <p>
                    Jaipur is the city of princes and princesses, of tales of
                    valour and courage, of romance and chivalry. Majestic forts,
                    luxurious palaces, lively temples, colourful bazaars,
                    vibrant streets, and pink face, have given the city a unique
                    and unmatched character that immediately endears itself to
                    every visitor.
                  </p>
                  <p>
                    Showing an amazing mix of modernity, traditions and old
                    world charm this city surges forward with its roots in the
                    past. A bustling metropolis today, it is the perfect example
                    of the very essence of India!
                  </p>

                  <p>
                    The Pink City, as Jaipur is popularly known, was not always
                    pink. Its main thoroughfares and buildings are painted
                    earthy pink in honour of the visiting Prince of Wales in
                    1876. It all came about due to the fact that it was thought
                    that the glaring white starkness of its buildings would be
                    too bright for the visiting prince and thus the idea to
                    paint buildings pink, came about. Today, every home within
                    the old city is obliged by law to maintain this facade. This
                    amazingly symmetrical and thoroughly proportioned city came
                    into existence as early as 1727 being the only city in India
                    which was conceptualized and conceived on such a grand
                    scale. Through the great vision and scholarly skills of
                    Maharaja Sawai Jai Singh II and extensive works by his Chief
                    Architect Vidyadhar Bhattacharji, Jaipur rose to fame as the
                    most beautiful and the best planned place to live in.
                    Liberal, protective and secular policies of the rulers
                    attracted a wide range of artisans, artists and businessmen,
                    which today make this city, a great arts, crafts, trade and
                    cultural centre. Architecturally, the city proved to be a
                    milestone and other great kings like Sawai Ram Singh and
                    Sawai Mansingh II added many more public buildings and
                    institutions to this existing masterpiece.
                  </p>

                  <p>
                    Through the great vision and scholarly skills of Maharaja
                    Sawai Jai Singh II and extensive works by his Chief
                    Architect Vidyadhar Bhattacharji, Jaipur rose to fame as the
                    most beautiful and the best planned place to live in.
                    Liberal, protective and secular policies of the rulers
                    attracted a wide range of artisans, artists and businessmen,
                    which today make this city, a great arts, crafts, trade and
                    cultural centre. Architecturally, the city proved to be a
                    milestone and other great kings like Sawai Ram Singh and
                    Sawai Mansingh II added many more public buildings and
                    institutions to this existing masterpiece.
                  </p>

                  <p>
                    Jaipur is surrounded on all sides by rugged hills, crowned
                    with forts and enclosed by embattled walls. The Old City,
                    the actual Pink City, is a great place to wander around.
                    Maharaja Man Singh II had the whole city painted pink when
                    the Prince of Wales, later Edward VII, visited Jaipur in
                    1876. Fabulous, tall houses with latticed windows line the
                    narrow streets of the old city, their rose pink colour
                    lending enchantment to a scene which is almost magical at
                    sunset. Today luxurious hotels and resorts offer comfortable
                    accommodation to all who wish to visit and the tourist
                    infrastructure is equally professionally handled.
                  </p>

                  <p>
                    Places of interest are the Jaipur Museum, Albert Museum,
                    Birla Mandir Planetarium, Sisodia Rani Park, Lakshmi Narain
                    Temple, Kanak Vrindavan, The Rajmahal Palace; Rambagh Palace
                    (now a Luxury hotel) and other parks. No matter what you
                    choose to do, your time in Jaipur will be remembered for a
                    long time to come.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Amer Fort
                  </h2>

                  <p>
                    Amber is located at a distance of 11 kilometers from Jaipur
                    and was the old fort of the Kachhwaha clan of Amber, which
                    used to be the capital, till it was moved to Jaipur. The
                    fort is built with white marble and red sandstone and look
                    even more attractive because of the Maota Lake in the
                    foreground. The fort in itself is a beautiful sight to
                    behold but as one looks on the fort with its clear
                    reflection on the lake in the front, one cannot help but
                    wonder if it is a dream or a beautiful illusion. The
                    tourists to this fort can either approach the fort by road
                    or take an elephant ride, which though is quite slow yet is
                    a lot of fun.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Hawa Mahal
                  </h2>
                  <p>
                    How often have we been told not to build castles in the air?
                    Very often indeed, but if you are a dreamer and wish to see
                    this 'palace of the winds' which is not just in your
                    imagination but a real palace, then come to the 'pink city'
                    of Rajasthan and see the Hawa Mahal. Each wall of the palace
                    reinforces the idea that 'dreams truly can come true', The
                    Hawa Mahal, which adjoins the famous City Palace wall, was
                    built in 1799 by Maharaja Sawai Pratap Singh and has now
                    become one of the major landmarks of Jaipur. The palace is
                    shaped like a pyramid and is a five-storied building, with a
                    number of small windows and screens, with arched roofs.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Jantar Mantar
                  </h2>
                  <p>
                    Jantar Mantar is another important tourist attraction in
                    Jaipur. Built by the astronomer king Sawai Jai Singh II,
                    Jantar Mantar is one of the five observatories built by the
                    king. The Jantar Mantar at Jaipur is the biggest and most
                    elaborate observatory in India. Constructed between 1728 and
                    1734, the Jantar Mantar is located in the center of Jaipur.
                    Maharaja Sawai Jai Singh built it to satisfy his quest to
                    find the mysteries of the sky as well as provide
                    satisfaction to his astronomical and architectural
                    instincts. The name "Jantar Mantar" is a modification of the
                    Hindi words "yantra" meaning instruments, and "mantra"
                    meaning formulae. It was built to study various phenomena of
                    astronomy like latitudes, longitudes, constellations, local
                    time, declination of the sun, planets and the stars, and to
                    determine eclipses. The monument was built to understand the
                    movements of the sun and moon and to find answers to various
                    other astronomical mysteries.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    City Palace
                  </h2>
                  <p>
                    The City Palace in Jaipur is an important landmark in the
                    Pink City. The City Palace complex is where the royalty of
                    Jaipur used to stay. The City Palace is a perfect blend of
                    Mughal and Rajput architecture. The palace complex was built
                    by Maharaja Jai Singh II and his successors made various
                    additions to the complex. The City Palace Complex has been
                    divided into courtyards, beautiful gardens, and buildings.
                    Some of the beautiful buildings in the City Palace complex
                    include Mubarak Mahal, Badal Mahal, Sh. Govind Dev Temple,
                    Chandra Mahal, and City Palace Museum. Tourism in Rajasthan
                    offers complete information on various tourist destinations
                    and hotels in Rajasthan. Tourism in Rajasthan also provides
                    an online booking facility for tour packages to Rajasthan
                    and hotel room booking in Rajasthan.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Nahargarh Fort
                  </h2>
                  <p>
                    Perched atop a picturesque hill, the Nahargarh Fort offers a
                    breathtaking view of the city below. Initially built by
                    Sawai Jain Singh in 1734 A.D. It was enlarged and given its
                    present shape by Sawai Madho Singh in 1885 A.D. Decorative
                    motifs in some of the rooms are delightful. From the windows
                    of the nine identical suites, one gets a magnificent view of
                    the city, complete with the geometrical layout. From Amer
                    there is a road to Nahargarh, which passes through the
                    hills.
                  </p>
                </div>
              </Col>
              <Col lg="4">
                {/* Add a newsletter component or other content in the right column */}
              </Col>
            </Row>
          </Container>
        </section>
      </div>
      <Newsletter />
    </>
  );
};

export default JaipurTour;
